export const ACTIVITY_LOG_URL = 'activity_log/page'
export const ACTIVITY_LOG_ERROR = 'ACTIVITY_LOG_ERROR'
export const ACTIVITY_LOG_LOADING = 'ACTIVITY_LOG_LOADING'
export const ACTIVITY_LOG_SUCCESS = 'ACTIVITY_LOG_SUCCESS'